import { ContextProviderProps } from 'config/types'
import { createContext, Dispatch, SetStateAction, useState } from 'react'

interface ContextType {
  email: string
  setEmail: Dispatch<SetStateAction<string>>
  verificationCode: string
  setVerificationCode: Dispatch<SetStateAction<string>>
}

const Contexts = createContext<ContextType>({
  email: '',
  setEmail: () => {},
  verificationCode: '',
  setVerificationCode: () => {},
})

const ContextProvider = ({ children }: ContextProviderProps) => {
  const [email, setEmail] = useState('')
  const [verificationCode, setVerificationCode] = useState('')

  return (
    <Contexts.Provider
      value={{ email, setEmail, verificationCode, setVerificationCode }}
    >
      {children}
    </Contexts.Provider>
  )
}

export { ContextProvider, Contexts }
